import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";

// Site::Video::ArticleContents::Component の Stimulus コントローラ。
// landIeul: ArticleContents。テーマタブ切替で記事スライダーを slideTo (transform) し、
// アクティブタブ・記事一覧ボタンを更新する。タイトル truncate は useIsSp (SP 26字 / PC 34字) を再現。

interface Theme {
  theme: string;
  themeTopUrl: string;
}

const NORMAL = "ThemeTubPagination_themePaginationTub";
const ACTIVE = "ThemeTubPagination_themePaginationTub_active";
const PC_MAX = 34;
const SP_MAX = 26;
const SCROLLBAR_MOVEMENT_PC = 50;
const SCROLLBAR_MOVEMENT_SP = 70;

class SiteVideoArticleContentsController extends Controller {
  static targets = ["tab", "tabBar", "sliderContainer", "sliderWrapper", "moreBtn"];
  static values = { themes: Array };

  declare readonly tabTargets: HTMLElement[];
  declare readonly tabBarTarget: HTMLElement;
  declare readonly sliderContainerTarget: HTMLElement;
  declare readonly sliderWrapperTarget: HTMLElement;
  declare readonly moreBtnTarget: HTMLButtonElement;
  declare readonly themesValue: Theme[];

  private activeIndex = 0;

  connect(): void {
    this.sliderWrapperTarget.style.transitionDuration = "300ms";
    this.truncateTitles();
    window.addEventListener("resize", this.truncateTitles);
  }

  disconnect(): void {
    window.removeEventListener("resize", this.truncateTitles);
  }

  private isSp(): boolean {
    return window.matchMedia("(max-width: 767px)").matches;
  }

  private truncateTitles = (): void => {
    const max = this.isSp() ? SP_MAX : PC_MAX;
    this.element
      .querySelectorAll<HTMLElement>(".ArticleContentsSlider_text")
      .forEach((el) => {
        const full = el.dataset.fullTitle || "";
        el.textContent = full.length > max ? `${full.slice(0, max)}...` : full;
      });
  };

  selectTheme(event: { params: { index: number } }): void {
    const index = Number(event.params.index);
    this.activeIndex = index;

    // 記事スライダーを slideTo
    const width = this.sliderContainerTarget.offsetWidth;
    this.sliderWrapperTarget.style.transform = `translate3d(${-index * width}px, 0, 0)`;

    // アクティブタブ更新
    this.tabTargets.forEach((tab, i) => {
      tab.className = i === index ? ACTIVE : NORMAL;
    });

    // タブバーをスクロール
    const movement = this.isSp() ? SCROLLBAR_MOVEMENT_SP : SCROLLBAR_MOVEMENT_PC;
    this.tabBarTarget.scrollTo({ top: 0, left: index * movement, behavior: "smooth" });

    // 記事一覧ボタン更新
    const theme = this.themesValue[index];
    if (theme) {
      this.moreBtnTarget.textContent = `${theme.theme}の記事一覧へ`;
    }
  }

  goToTheme(): void {
    const theme = this.themesValue[this.activeIndex];
    if (theme) {
      window.location.href = theme.themeTopUrl;
    }
  }
}

application.register("site--video--article-contents", SiteVideoArticleContentsController);
